const TipoAbitazioneLuogoEnum = {
    SERVITA: 1,
    POCO_SERVITA: 2,
    ISOLATA: 3,
  };
  
  TipoAbitazioneLuogoEnum.getLabel = function (value) {
    switch (value) {
      case this.SERVITA:
        return "Centrale e servita";
      case this.POCO_SERVITA:
        return "Poco servita";
      case this.ISOLATA:
        return "Isolata";
      default:
        return value;
    }
  };
  
  export default TipoAbitazioneLuogoEnum;

